type SVGProps = {
  width?: string | number;
  height?: string | number;
};

const Chevron = ({ width, height }: SVGProps) => (
  <svg
    focusable={false}
    width={width}
    height={height}
    viewBox='-5 -5 15 15'
    version='1.1'
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g fill='#4B286D'>
        <path d='M3.47896519,2.04146925 L1.48838722,4.03204723 C1.14789805,4.37253639 0.595856041,4.37253639 0.255366875,4.03204723 C-0.0851222915,3.69155806 -0.0851222915,3.13951605 0.255366875,2.79902688 L2.79902688,0.255366875 C2.98541428,0.0689794777 3.23519527,-0.0153774724 3.47896519,0.00229602404 C3.72273512,-0.0153774724 3.97251611,0.0689794777 4.1589035,0.255366875 L6.70256351,2.79902688 C7.04305268,3.13951605 7.04305268,3.69155806 6.70256351,4.03204723 C6.36207435,4.37253639 5.81003233,4.37253639 5.46954317,4.03204723 L3.47896519,2.04146925 Z' />
      </g>
    </g>
  </svg>
);

export default Chevron;
